import { render, staticRenderFns } from "./CreateFaculty.vue?vue&type=template&id=15595a03&scoped=true"
import script from "./CreateFaculty.vue?vue&type=script&lang=js"
export * from "./CreateFaculty.vue?vue&type=script&lang=js"
import style0 from "./CreateFaculty.vue?vue&type=style&index=0&id=15595a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15595a03",
  null
  
)

export default component.exports